import {useQuantityFormat} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Text} from '../../atoms/Text/Text';
import {CountBadgeProps} from './types';

export const CountBadge: FC<CountBadgeProps> = ({itemCount, theme}) => {
  const format = useQuantityFormat();

  return (
    <StyledText data-is-dark-theme={theme === 'dark'} size="px14">
      {format(itemCount)}
    </StyledText>
  );
};

const StyledText = styled(Text)`
  line-height: 1.2;
  padding: 3px 4px;
  border-radius: 2px;
  background-color: transparent;
  color: ${COLORS['Text.Grey']};

  &[data-is-dark-theme='true'] {
    background-color: ${COLORS['Fill.Black']};
    color: ${COLORS['Text.White']};
  }
`;
